// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767.98px) {
    .header-navbar .navbar-header {
        width: 100% !important;
        top: 3px;
    }
}

.dropdown-menu-right {
  right: 0;
  left: auto;
  top: auto;
}

.header-navbar .navbar-header .navbar-brand .brand-text {
  color: #4c3a00 !important;
}

.header-navbar .navbar-header .navbar-brand .brand-logo {
  height: 44px !important;
  width: auto;
  object-fit: contain;
}

/* .navbar-light {
    z-index: 1038 !important;
} */
`, "",{"version":3,"sources":["webpack://./src/app/_layout/header/horizontal/horizontal.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;GAEG","sourcesContent":["@media (max-width: 767.98px) {\n    .header-navbar .navbar-header {\n        width: 100% !important;\n        top: 3px;\n    }\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n  top: auto;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-text {\n  color: #4c3a00 !important;\n}\n\n.header-navbar .navbar-header .navbar-brand .brand-logo {\n  height: 44px !important;\n  width: auto;\n  object-fit: contain;\n}\n\n/* .navbar-light {\n    z-index: 1038 !important;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
